import { Button, Stack, Typography } from "@mui/material";
import { useNavigate } from "@tanstack/react-router";
import useLocales from "src/hooks/useLocales";
import { PATH_AUTH } from "src/utils/paths";

import SendEmailForm from "./SendEmailForm";

// ----------------------------------------------------------------------

export default function SendEmailSection() {
	const { translate } = useLocales();
	const navigate = useNavigate();
	return (
		<Stack textAlign={"center"} alignItems={"center"}>
			<Typography paragraph variant='h3'>
				{translate("¿Olvidaste la contraseña?")}
			</Typography>

			<Typography sx={{ color: "text.secondary", mb: 5 }}>
				{translate(
					"Por favor introduce tu email asociado a tu cuenta y te enviaremos un correo con el link para añadir una nueva."
				)}
			</Typography>

			<Stack width={{ xs: "auto", sm: 400 }}>
				<SendEmailForm />
				<Button
					fullWidth
					size='large'
					sx={{ mt: 1 }}
					onClick={() => navigate({ to: PATH_AUTH.login })}
				>
					Volver
				</Button>
			</Stack>
		</Stack>
	);
}
